import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Card, CardContent, CardHeader, Typography, Box, Chip } from '@mui/material';
import {
  Quiz as TestIcon,
  Assessment as ScoreIcon,
  School as LevelIcon,
  AutoGraph as ProcessIcon
} from '@mui/icons-material';

const useStyles = makeStyles()((theme) => ({
  root: {
    boxShadow: theme.shadows[3],
    height: "100%"
  },
  header: {
    backgroundColor: theme.palette.primary.light + '10',
    '& .MuiTypography-root': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  content: {
    padding: theme.spacing(3),
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  icon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  value: {
    fontWeight: 500,
  },
  chip: {
    margin: theme.spacing(0.5, 0.5, 0, 0),
  }
}));

export const DiagnosticTestInfo = () => {
  const { classes } = useStyles();

  const detailsConfig = [
    {
      icon: <TestIcon />,
      label: 'What is it?',
      value: 'An assessment to determine your current level'
    },
    {
      icon: <ProcessIcon />,
      label: 'How does it work?',
      value: 'Questions adapt based on your responses to accurately assess your level'
    },
    {
      icon: <ScoreIcon />,
      label: 'Scoring System',
      value: 'Based on performance accuracy',
      chips: [
        { label: 'Higher Score → Advanced Level', color: 'success' },
        { label: 'Lower Score → Foundation Level', color: 'primary' }
      ]
    },
    {
      icon: <LevelIcon />,
      label: 'Course Assignment',
      value: 'Automatic placement into the right course based on level',
      chips: [
        { label: 'Level 4, 5 (Sparkle)', color: 'success' },
        { label: 'Level 0,1,2,3 (Ember)', color: 'primary' }
      ]
    }
  ];

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        title={
          <Typography variant="h5" component="h2">
            Understanding Diagnostic Test
          </Typography>
        }
      />
      <CardContent className={classes.content}>
        {detailsConfig.map((detail, index) => (
          <Box key={index} className={classes.infoRow}>
            <Box className={classes.icon}>
              {detail.icon}
            </Box>
            <Box>
              <Typography className={classes.label}>
                {detail.label}
              </Typography>
              <Typography className={classes.value}>
                {detail.value}
              </Typography>
              {detail.chips && (
                <Box>
                  {detail.chips.map((chip, chipIndex) => (
                    <Chip
                      key={chipIndex}
                      label={chip.label}
                      color={chip.color}
                      size="small"
                      className={classes.chip}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};